import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';

const ScrollTrack = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  overflowX: 'auto',
  scrollSnapType: 'x mandatory',
  paddingBottom: theme.spacing(0.5),
  WebkitOverflowScrolling: 'touch',
}));

const ScrollItem = styled(Box)(({ theme }) => ({
  flex: '0 0 auto',
  scrollSnapAlign: 'start',
  width: 'min(85vw, 300px)',
  [theme.breakpoints.up('sm')]: {
    width: 280,
  },
}));

interface HorizontalScrollRowProps {
  children: ReactNode;
}

export function HorizontalScrollRow({ children }: HorizontalScrollRowProps) {
  return <ScrollTrack>{children}</ScrollTrack>;
}

interface HorizontalScrollRowItemProps {
  children: ReactNode;
}

export function HorizontalScrollRowItem({ children }: HorizontalScrollRowItemProps) {
  return <ScrollItem>{children}</ScrollItem>;
}
